<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column overflow-auto>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="[
                      'btnRetrieve', //Retrieve
                    ]"
                    @btnRetrieve="btnRetrieve()"
                  >
                    <template v-slot:body>
                      <v-layout column>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-1 subTitle">User ID: </span>
                          <v-col cols="2">
                            <v-text-field 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable
                              v-model="userId"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> User Name: </span>
                          <v-col cols="3">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              v-model="userName"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                          <v-icon small color="blue" class="pl-2">mdi-circle</v-icon>
                          <span class="pa-1 subTitle"> Use Y/N: </span>
                          <v-col cols="1">
                            <v-text-field class="popField" 
                              dense 
                              outlined 
                              hide-details="auto"
                              clearable 
                              v-model="useYn"
                              @keydown.enter="btnRetrieve()"
                            />
                          </v-col>
                        </v-row>
                      </v-layout>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="12" align="right" class="pr-2 customer">* Password Initialize : Click PW term / Change Use Div : Click Use</v-col>
                  </v-row>
                  <DxDataGrid id="epmsZ030" 
                    class="hipGridHeight2" 
                    :ref="epmsZ030Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxColumn data-field="rnum" caption="NO" width="3%" data-type="string" alignment="center" :visible="true" />
                    <DxColumn data-field="usrId" caption="ID" width="7%" data-type="string" alignment="center" />
                    <DxColumn data-field="custNm" caption="Customer Name" width="20%" data-type="string" alignment="left" :allow-editing="true" />
                    <DxColumn data-field="custNo" caption="Ref. No" width="10%" data-type="string" alignment="center" :allow-editing="true" />
                    <DxColumn data-field="represent" caption="Represent" width="10%" data-type="string" alignment="center" :allow-editing="true" />
                    <DxColumn data-field="tel" caption="Tel" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="fax" caption="Fax" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="lastLogin" caption="Last Login" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="pwChangeDte" caption="Change PW" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    <DxColumn data-field="pwTerm" caption="PW term" width="7%" data-type="string" alignment="right" :allow-editing="false" cell-template="pwTermTemplate" />
                      <template #pwTermTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 pwTermBtn" @click="pwTermBtn(data)">
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxColumn data-field="useYn" caption="Use" width="3%" data-type="string" alignment="center" :allow-editing="false" cell-template="useYnTemplate" />
                      <template #useYnTemplate="{ data }">
                        <v-btn small elevation="0" color="transparent" class="px-1 py-0 pwTermBtn" @click="useYnBtn(data)">
                          {{data.text}}
                        </v-btn>
                      </template>
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="auto" class="pa-6 pb-0 pt-2 pr-2 header">
                  Make New ID
                </v-col>
                <v-col cols="full" style="border: 1px solid gray;">
                  <v-row no-gutters>
                    <v-col cols="2" class="pa-1">
                      <v-text-field 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        v-model="makeID"
                        maxLength="5"
                        @keydown.enter="MakeId()"
                      />
                    </v-col>
                    <v-col cols="auto">
                      <v-icon small class="pt-3 pl-3">
                        mdi-arrow-right-box
                      </v-icon>
                      <v-btn small elevation="0" color="transparent" class="pt-3 pl-0 MakeId" @click="MakeId" >
                        Make New ID 
                      </v-btn>
                    </v-col>
                    <v-col class="pa-2">
                      <span class="bottomMessege"> ** User ID must be same with Customer Code.</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn , DxButton } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getUserList , passwordInitialize , updateDisable , updateEnable , createNewId } from '@/api/view/hip/Z/epmsZ030.js'

export default {
  name: 'epmsZ030',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxButton,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useDivList: [],
      useDiv: '',

      epmsZ030Ref: 'epmsZ030Ref',
      gridMainList: [],
      makeID: '',

      userId: '',
      userName: '',
      useYn: ''

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epmsZ030Ref)
    },
  },
  mounted(){
    this.doSearchMain()
  },
  methods: {
    btnRetrieve(){
      if(this.userId === null){
        this.userId = ''
      } else if(this.userName === null){
        this.userName = ''
      } else if(this.useDiv === null){
        this.useDiv = ''
      }
      this.doSearchMain()
    },
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        usrId: this.userId,
        custNm: this.userName,
        useYn: this.useYn
      }
      await getUserList(params).then(res => {
        // console.log(" RES : " , res)
        this.gridMainList = res.list
      }).finally(() => {
        this.endLoading()
      })

    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        e.cellElement.style.padding = '1px'
      }
    },
    MakeId(){
      let params = [{
        usrId: this.makeID
      }]
      if(this.makeID === '' || this.makeID === null){
        this.vToastify(this.$t('Input new id.'), 'warn')
      } else {
        this.vToastifyPrompt(
          this.$t('Do you want to make new ID?'),
        'info',
          current => {
            this.openLoading('searching')
            createNewId(params)
              .then(res => {
                notify(this.$t('Saved'), 'success', 1500)
                this.doSearchMain()
                this.makeID = ''
              })
              .catch(error => {
                notify(error, 'error', 1500)
                this.endLoading()
              })
              .finally(() => {
                this.endLoading()
              })
          },
          null,
          true
        )
      }
    },
    //Password Initialize
    pwTermBtn(e){
      let params = [{
        revEmp: this.$store.state.user.makerCd,
        usrId: e.values[1]
      }]
      this.vToastifyPrompt(
        this.$t('selected user passwoed will be cleared.' + '<br>' + ' new password is same with user ID ' + '<br>' + 'continue?'),
      'info',
        current => {
          this.openLoading('searching')
          passwordInitialize(params)
            .then(res => {
              notify(this.$t('resetPassword'), 'success', 1500)
              this.doSearchMain()
            })
            .catch(error => {
              notify(error, 'error', 1500)
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
      )
    },
    //Change Use Div
    useYnBtn(e){
      let params = [{
        revEmp: this.$store.state.user.makerCd,
        usrId: e.values[1]
      }]
      if(e.value === 'Y'){
        this.vToastifyPrompt(
        this.$t('Disable user.' + '<br>' + 'From now on the selected user cannot log on to HiP Program.'+ '<br>' + 'Continue?'),
        'info',
        current => {
          this.openLoading('searching')
          updateDisable(params)
            .then(res => {
              notify(this.$t('changed'), 'success', 1500)
              this.doSearchMain()
            })
            .catch(error => {
              notify(error, 'error', 1500)
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
        )
      }else {
        this.vToastifyPrompt(
        this.$t('Enable user.' + '<br>' + 'From now on the selected user can log on to HiP Program.' + '<br>' + 'Continue?'),
        'info',
        current => {
          this.openLoading('searching')
          updateEnable(params)
            .then(res => {
              notify(this.$t('changed'), 'success', 1500)
              this.doSearchMain()
            })
            .catch(error => {
              notify(error, 'error', 1500)
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        },
        null,
        true
        )
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .subTitle {
    font-weight: bold;
    color: black;
  }
  .customer {
    color: blue;
    font-weight: bold;
  }
  .header {
    border: 1px solid gray;
    background-color: rgb(223,227,213);
    color: black;
  }
  .MakeId {
    font-weight: bold;  
  }
  .MakeId:hover {
    color: #4980BC;
  }
  .pwTermBtn {
    font-weight: bold;
  }
  .pwTermBtn:hover {
    color: #4980BC;
  }
  .bottomMessege {
    color: black;
  }
</style>